import { axios } from '@Root/API'

export const edit = data => {
	return axios.put('students/course-session/update', data)
}
